<template>
  <div
    v-if="report"
    class="report_item_sidebar"
  >
    <button class="sidebar_toggle" />
    <div class="report_item_sidebar_elem">
      <span class="report_name">
        {{ report.name }}
        <a
          class="edit_report"
          href="javascript:;"
          @click="openReportModal({report: report, type: type})"
        >
          <i class="icon edit_icon" />
        </a>
      </span>
      <div class="report_sections">
        <div class="name mb_12">
          Report Pages
        </div>

        <div
          id="page_accordion"
          class="page_accordion"
        >
          <div
            v-for="(page, index) in pages"
            :key="index"
            :class="'accordion_wrapper '+(selected === page.id ? 'active' : '')"
          >
            <div
              class="accordion_head"
              @click="selected = page.id; scrollToPage(page.id);"
            >
              <span class="p_body">Page {{ page.position }}</span>

              <button
                class="delete"
                @click="deletePage({ pageId: page.id, reportId: report.id, type: type })"
              />
              <svg
                fill="none"
                height="16"
                viewBox="0 0 16 16"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 8H13.5"
                  stroke="#4E4E54"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.33"
                />
                <path
                  d="M8 2.5V13.5"
                  stroke="#4E4E54"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.33333"
                />
              </svg>
            </div>
            <accordion-transition>
              <div
                v-show="selected === page.id"
                class="accordion_body"
              >
                <div
                  v-for="(widget, widgetIndex) in page.layout"
                  :key="widgetIndex"
                  class="report_accordion_section_label"
                >
                  <span class="p_body">{{ widget.name || generateWidgetTitle(widget) }}</span>
                  <div class="btns">
                    <!--<button class="copy"></button>-->
                    <button
                      class="edit"
                      @click="openWidgetModal({ modal: widget.type, widget: widget, pageId: page.id})"
                    />
                    <button
                      class="delete"
                      @click="deleteWidget({widget: widget, pageId: page.id})"
                    />
                  </div>
                </div>
                <a
                  class="add_widget_btn"
                  href="javascript:;"
                  @click="addWidget(page.id, page.position)"
                >
                  <svg
                    fill="none"
                    height="23"
                    viewBox="0 0 22 23"
                    width="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.78125 11.5H18.2187"
                      stroke="#37B2A8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                    <path
                      d="M11 3.9375V19.0625"
                      stroke="#37B2A8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                  </svg>
                  <span>Add Widget</span>
                </a>
              </div>
            </accordion-transition>
          </div>
        </div>

        <a
          class="add_page_btn"
          href="javascript:;"
          @click="addPage({reportId: report.id, isTemplate: report.is_template})"
        >
          <svg
            fill="none"
            height="23"
            viewBox="0 0 22 23"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.78125 11.5H18.2187"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M11 3.9375V19.0625"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
          <span>Add Page</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {mapActions, mapState} from 'vuex';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';

export default {
  components: {AccordionTransition},
  props: {
    visiblePage: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      selected: 0
    }
  },
  computed: {
    ...mapState('report', ['report', 'type']),
    ...mapState('pages', ['pages']),
  },
  watch: {
    visiblePage: {
      handler() {
        const index = _.findIndex(this.pages, (o) => {
          return o.id === this.visiblePage;
        });
        if (this.pages[index]) this.selected = parseInt(this.pages[index].id);
      }
    },

  },
  methods: {
    ...mapActions({
      openWidgetModal: 'widgetModal/openModal',
      openReportModal: 'reportModal/openModal',
      addPage: 'pages/addPage',
      movePageUp: 'pages/movePageUp',
      movePageDown: 'pages/movePageDown',
      deleteWidget: 'pages/deleteWidget',
      deletePage: 'pages/deletePage'
    }),

    addWidget(pageID) {
      this.openWidgetModal({modal: 'new', widget: null, pageId: pageID});
    },

    generateWidgetTitle(widget) {
      let title = '';
      switch (widget.type) {
        case 'ga':
          title = 'Google Analytics';
          break;
        case 'gsc':
          title = 'Google Search Console';
          break;
        default:
          title = _.capitalize(widget.type)
      }
      return title + ' Widget';
    },

    scrollToPage(id) {
      let page = document.getElementById('p' + id);
      let pagePosition = (page.getBoundingClientRect().top + window.pageYOffset);
      document.documentElement.scrollTop = pagePosition - 100;
    }
  },
}
</script>

<style scoped>

.accordion_body {
  transition: 300ms;
}

.page_accordion .accordion_wrapper.active .accordion_head {
  background-color: #37B2A8;
}

.report_item_sidebar {
  position: -webkit-sticky;
  position: sticky;
  height: calc(100vh - 65px);
  overflow: scroll;
  top: 65px;
}

.report_item_sidebar_elem {
  padding: 1.5rem 2.5rem 1.5rem;
  background-color: #E8E5E2;
  overflow: auto;
  height: calc(100vh - 65px);
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-width: 23.75rem;
  width: 25vw;
}

.add_widget_btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 55px;
  color: #37B2A8;
  width: 100%;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.add_widget_btn svg path {
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.add_widget_btn:hover {
  background-color: #37B2A8;
  color: #fff
}

.add_widget_btn:hover svg path {
  stroke: #fff
}

.add_widget_btn svg {
  margin-right: 10px;
}

.add_page_btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 55px;
  background-color: #37B2A8;
  color: #fff;
  width: 100%;
  border-radius: .75rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.add_page_btn:hover {
  background-color: #216e68;
}

.add_page_btn svg {
  margin-right: 10px;
}


.accordion_head > button {
  margin-left: 1rem
}

.accordion_head .move-page {
  display: none;
}

.accordion_head .delete {
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.8745 4.375L3.12451 4.37501' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M8.125 8.125V13.125' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M11.875 8.125V13.125' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M15.6245 4.375V16.25C15.6245 16.4158 15.5587 16.5747 15.4415 16.6919C15.3242 16.8092 15.1653 16.875 14.9995 16.875H4.99951C4.83375 16.875 4.67478 16.8092 4.55757 16.6919C4.44036 16.5747 4.37451 16.4158 4.37451 16.25V4.375' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375' stroke='%23F34F4F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  width: 1.25rem;
  height: 1.25rem;
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  display: none;
}

.accordion_wrapper.active .accordion_head .delete,
.accordion_wrapper.active .accordion_head .move-page {
  display: block;
}


/* Hide scrollbar for Chrome, Safari and Opera */
.report_item_sidebar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.report_item_sidebar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.report_name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: .75rem;
  padding: 1rem;
  border: 1px solid #040707;
  margin-bottom: 2.5rem;
  line-height: 1.45;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.125rem;
}

.edit_report {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
